import React from "react";
import Container from "react-bootstrap/Container";

import LineSeparator from "../../common/components/LineSeparator";
import { PALETTE } from "../../common/ThemeConstants";
import Logo from "../../common/images/logoDisabled.png";

export default function Failed({
  separatorText = "Error",
  mainDescription,
  secondaryDescription,
  children = <></>,
  paddingTop = "70px",
}) {
  return (
    <Container
      className="align-self-center text-center"
      style={{ paddingTop: paddingTop, width: "300px" }}
    >
      <img
        width={200}
        src={Logo}
        alt="Federico Bartoli PT"
        style={{ maxWidth: "100%" }}
      ></img>
      <Container style={{ maxWidth: "100%" }}>
        <LineSeparator text={separatorText} textColor={PALETTE.BLACK} />
      </Container>
      <br />
      <p style={{ color: PALETTE.GRAY }}>{mainDescription}</p>
      <p style={{ color: PALETTE.GRAY }}>{secondaryDescription}</p>
      {children}
    </Container>
  );
}
